module.exports = __webpack_public_path__ + "img/2x2.1cde8d64.svg";